import { Typography } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

export interface TopBarChartEntry {
  key: string;
  name: string;
  count: number;
}

/** Horizontal top-N bar chart shared across the Agent Usage panel and its drill-down detail modal. Bars are clickable when onEntryClick is given. */
const TopBarChart = ({
  data, color, tooltipSuffix, emptyMessage, onEntryClick,
}: {
  data: TopBarChartEntry[];
  color: string;
  tooltipSuffix: string;
  emptyMessage: string;
  onEntryClick?: (entry: TopBarChartEntry) => void;
}) => {
  if (data.length === 0) {
    return <Typography color="text.secondary">{emptyMessage}</Typography>;
  }
  return (
    <ResponsiveContainer width="100%" height={Math.max(180, data.length * 44)}>
      <BarChart data={data} layout="vertical" margin={{ top: 10, right: 30, left: 10, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e8eaf0" horizontal={false} />
        <XAxis type="number" tick={{ fontSize: 11, fill: '#64748b' }} tickLine={false} axisLine={{ stroke: '#cbd5e1' }} allowDecimals={false} />
        <YAxis type="category" dataKey="name" width={160} tick={{ fontSize: 11, fill: '#334155' }} tickLine={false} axisLine={false} />
        <Tooltip
          formatter={(value: number) => [`${value.toLocaleString()} ${tooltipSuffix}`, '']}
          labelFormatter={() => ''}
        />
        <Bar
          dataKey="count"
          name={tooltipSuffix}
          radius={[0, 8, 8, 0]}
          maxBarSize={24}
          onClick={onEntryClick}
          cursor={onEntryClick ? 'pointer' : undefined}
        >
          {data.map((entry) => (
            <Cell key={entry.key} fill={color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TopBarChart;
